import { Pipe, PipeTransform } from "@angular/core";
import { nonNullish } from "src/guards";

@Pipe({
  name: "filterNonNullish",
})
export class FilterNonNullishPipe implements PipeTransform {
  transform<T extends readonly unknown[]>(value: T): NonNullable<T[number]>[] {
    return value.filter(nonNullish);
  }
}
